export default "https://cdn-static.gokick.com/assets/09fae944e838c54f14fd77486c4f90b3472cb396/images/sleep-green-apple.f7a444510e3da94f2e4fec3a465032b1.png";